export default "__VITE_ASSET__eXF8dd7m__"